import { RouteObject } from 'react-router';

import { LiveMapRoute } from './LiveMapRoute';

export const liveMapRoutes: RouteObject[] = [
  {
    index: true,
    element: <LiveMapRoute />,
  },
];
